var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product"},[_c('div',{staticClass:"thankyou"},[_vm._v(" "+_vm._s(_vm.$t('waitForRedirect'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }